import { useEffect, useRef } from 'react';

/**
 * Web OTP API (Chrome Android): SMS ichidagi "@hostname #1234" qatoridan kodni oladi.
 * iOS Safari uchun input autocomplete="one-time-code" ishlatiladi (alohida).
 */
export function useWebOtp({ enabled, codeLength = 4, onCode }) {
  const onCodeRef = useRef(onCode);
  onCodeRef.current = onCode;

  useEffect(() => {
    if (!enabled) return undefined;
    if (typeof window === 'undefined') return undefined;
    if (!('OTPCredential' in window)) return undefined;

    const ac = new AbortController();

    navigator.credentials
      .get({
        otp: { transport: ['sms'] },
        signal: ac.signal,
      })
      .then((otp) => {
        const raw = otp?.code ?? '';
        const digits = String(raw).replace(/\D/g, '').slice(0, codeLength);
        if (digits.length === codeLength) {
          onCodeRef.current(digits);
        }
      })
      .catch(() => {
        /* foydalanuvchi rad etdi yoki brauzer qo‘llab-quvvatlamaydi */
      });

    return () => ac.abort();
  }, [enabled, codeLength]);
}
